module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_uzdevumi_mobile-7aa7e56f245c4689392223848837b547.webp";